import { getCustomerEntity } from "../../../services/api/onboarding/customer";
import { getVerifications } from "../../../services/api/onboarding/verifications";

export const selectorIsUsPersonVerificationAvailable = (
  monitoredEntity: Awaited<ReturnType<typeof getCustomerEntity>> | undefined,
  verifications: Awaited<ReturnType<typeof getVerifications>> | undefined
) => {
  const country = monitoredEntity?.country;
  const type = monitoredEntity?.type;
  const usVerificationStatus = verifications?.profiles?.["US"]?.tax;

  const isNonUSUser = country ? country !== "US" : false;
  const isIndividual = type === "Individual";
  const isUSUsedNonVerified =
    usVerificationStatus !== "Verified" && usVerificationStatus !== "Pending";

  return isNonUSUser && isIndividual && isUSUsedNonVerified;
};
